import {z} from 'zod';
import type {FeatureFlagsConfig} from './is-feature-flag-enabled.js';

const ALLOWED_MARKETS = [
  `DK`,
  `DE`,
  `SE`,
  `IT`,
  `FR`,
  `ES`,
  `UK`,
  `PT`,
  `AT`,
  `BE`,
] as const;

const MarketStruct = z.object(
  Object.fromEntries(
    ALLOWED_MARKETS.map((market) => [market, z.boolean().optional()]),
  ),
);

const FeatureFlagSchema = z.object({
  enabledGlobally: z.boolean(),
  markets: MarketStruct,
});

export function validateFeatureFlagsConfig(
  featureFlagsConfig: FeatureFlagsConfig,
  usedFeatureFlags: string[],
): FeatureFlagsConfig {
  const featureFlagsConfigKeysSet = new Set(Object.keys(featureFlagsConfig));
  const flagMissingInConfig = usedFeatureFlags.some(
    (flag) => !featureFlagsConfigKeysSet.has(flag),
  );

  if (flagMissingInConfig) {
    throw new Error(
      `Invalid feature flags found in feature flags config. Used feature switches are: ${usedFeatureFlags.join(
        `, `,
      )}`,
    );
  }

  Object.values(featureFlagsConfig).forEach((config) => {
    FeatureFlagSchema.parse(config);
  });

  return featureFlagsConfig;
}
